import type { ReactNode } from 'react';

import { ButtonBase } from '@mui/material';
import { useSearchParams } from 'react-router';

import { FACTSHEET_PARAM_NAME } from '@/features/Factsheet/constants';
import getFactsheetLink from '@/features/Factsheet/utils/getFactsheetLink';

const FactsheetDialogButtonBase = ({
  code,
  children,
  mode = 'modal'
}: {
  code: string;
  children: ReactNode;
  mode?: 'modal' | 'newTab';
}) => {
  const [, setSearchParams] = useSearchParams();
  return (
    <ButtonBase
      onClick={e => {
        e.stopPropagation();
        if (mode === 'newTab') {
          window.open(getFactsheetLink(code), '_blank');
          return;
        }
        setSearchParams(prev => {
          prev.set(FACTSHEET_PARAM_NAME, code);
          return prev;
        });
      }}
    >
      {children}
    </ButtonBase>
  );
};
export default FactsheetDialogButtonBase;
